import { render, staticRenderFns } from "./SelesaiPelayanan.vue?vue&type=template&id=3f412a00"
import script from "./SelesaiPelayanan.vue?vue&type=script&lang=js"
export * from "./SelesaiPelayanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f412a00')) {
      api.createRecord('3f412a00', component.options)
    } else {
      api.reload('3f412a00', component.options)
    }
    module.hot.accept("./SelesaiPelayanan.vue?vue&type=template&id=3f412a00", function () {
      api.rerender('3f412a00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/SelesaiPelayanan.vue"
export default component.exports